export const SIZES = ["sm", "md", "lg"] as const;

export const ORIENTATIONS = ["vertical", "horizontal"] as const;

export const RADII = ["none", "xs", "sm", "md", "lg", "xl", "full"] as const;

export const TRANSITION_FAST_MS = 150;

export const TRANSITION_NORMAL_MS = 200;

export const TRANSITION_SLOW_MS = 300;

export const TRANSITION_EXIT_MS = 100;
